import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SplitCurrencyPipe } from 'app/shared/pipes/split-currency.pipe';

@Component({
    selector: 'app-display-price',
    imports: [SplitCurrencyPipe],
    templateUrl: './display-price.component.html',
    styleUrl: './display-price.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'aria-live': 'polite',
    },
})
export class DisplayPriceComponent {
    @Input()
    public price: number | undefined;
}
